
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { namespace } from 'vuex-class';
import _ from 'lodash';
import rest from '@/rest';
import { vuex } from "@/store";
import { signalrEventBus } from "@/main";
import { List } from 'linq-collections';
import ExpandableCard from '../Shared/ExpandableCard.vue';
import BundleSelection from './BundleSelection.vue';
import { ParamDictionary } from '@/interfaces/ParamDictionary';
import { ExBundleVM } from '@/interfaces/ExBundleAssignmentGroupVM';

interface Step {
  title: string;
  description: string;
  isValid: boolean;
}

const globals = namespace("globals");
const ux = namespace("ux");

@Component({
  components: {
    BundleSelection,
    ExpandableCard,
  }
})
export default class ReplaceOldCourseWizardDlg extends Vue {
  $refs!: {
    // mediaPool: MediaPool;
    // form1: HTMLFormElement;
    // form2: HTMLFormElement;
    // form3: HTMLFormElement;
    // mdCreateCard: any;
  };

  @PropSync("showDialog") syncedShowDialog!: boolean;

  @globals.Getter selectedBundle!: ExBundleVM | null;
  @globals.Action refreshSelectedBundle!: () => Promise<void>;
  @ux.Getter gradientBackground: any;
  @ux.Getter gradientBackground2: any;
  @ux.Getter gradientBackground3: any;
  @ux.Getter gradientText: any;

  isBusy = false;
  bundleZipCreationBusy = false;
  guid: string = "";
  currentStepIndex = 1;
  steps: Step[] = [
    {
      title: 'Alte Schulung auswählen',
      description: 'Wählen Sie die Schulung aus, die durch die Autorentool-gestützte Schulung ersetzt werden soll',
      isValid: false,
    },
    {
      title: 'Backup erstellen',
      description: 'Erstellen Sie ein Backup der bestehenden Schulung, um Datenverlust zu vermeiden',
      isValid: false,
    },
    {
      title: 'Schulung ersetzen',
      description: 'Ersetzen Sie die bestehende Schulung durch eine leere Schulung, die im Autorentool weiterbearbeitet werden kann',
      isValid: true,
    },
  ];

  created() {
    // SignalR event listener
    signalrEventBus.$on('zipArchiveCreationFinished', this.zipArchiveCreationFinished);
    // document.addEventListener('keydown', this.handleKeyNavigation);
  }

  beforeDestroy() {
    // Make sure to cleanup SignalR event handlers when removing the component
    signalrEventBus.$off('zipArchiveCreationFinished', this.zipArchiveCreationFinished);
    // document.removeEventListener('keydown', this.handleKeyNavigation);
  }

  // SignalR events
  zipArchiveCreationFinished(response: any) {
    console.log("ReplaceOldCourseWizardDlg > Zip archive creation finished:", response.zipFilePath + " " + response.message);
    // if (response.status == "SUC") {
    //   this.$globalHelper.downloadFile(response.zipFilePath);
    // } else {
    // }

    // this.$emit('content:ZipArchiveCreationFinished');
    this.bundleZipCreationBusy = false;
    this.steps[1].isValid = true;
  }

  @Watch("syncedShowDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.syncedShowDialog) {
      // On dialog open
      this.currentStepIndex = 1;
      vuex.globals.setBundle(null);
      this.steps[0].isValid = false;
      this.steps[1].isValid = false;

      // Disable body scroll on iOS
      this.$nextTick(async () => {
        await this.$globalHelper.delay(10);
        const modal = document.querySelector('.modal');
        disableBodyScroll(modal);
      });
    } else {
      // Dialog closing
      clearAllBodyScrollLocks();
    }
  }

  // @Watch('currentStepIndex')
  // async onStepChange(newIndex: number) {
  //   this.$emit('step-change', newIndex, this.steps[newIndex - 1]);

  //   Step 3: Schulung ersetzen
  //   if (newIndex == 3) {
  //     await this.$globalHelper.delay(10);
  //     this.updateForm3Validity();
  //   }
  // }

  // updateForm3Validity(): void {
  //   this.$set(this.steps[2], 'isValid', this.allFilesProcessed);
  // }

  onBundleSelected(bundle: ExBundleVM) {
    vuex.globals.setBundle(bundle);
    this.$set(this.steps[0], 'isValid', true);
  }

  async createBundleZipFile() {
    this.bundleZipCreationBusy = true;

    await this.$l3rnOnlineHub.ensureConnection();

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["SignalRId"] = this.$l3rnOnlineHub.ConnectionId!;
    params.dictionary!["BundleId"] =  this.selectedBundle!.id.toString();

    await rest.url("contentManager/createBundleZipFile")
      .post(params)
      .then((guid) => {
        this.guid = guid;
      });
  }

  async onReplaceOldCourse() {
    this.isBusy = true;

    try {
      let response = await rest.url("contentManager/replaceOldCourse").post(this.selectedBundle);
      console.log("ReplaceOldCourse response:", response);
      if (response == true) {
        this.$emit('finished:replaceOldCourseWizardDlg');
        this.onClose();
      }
    } catch (error) {
      console.error("Fehler beim Aktualisieren des Bundles:", error);
    } finally {
      this.isBusy = false;
    }
  }

  get currentStep(): Step {
    return this.steps[this.currentStepIndex - 1];
  }

  get isLastStep(): boolean {
    return this.currentStepIndex === this.steps.length;
  }

  get isCurrentStepValid(): boolean {
    if (!this.syncedShowDialog) return false;

    return this.currentStep.isValid;
  }

  validateCurrentStep(): void {
    // switch (this.currentStepIndex) {
    //   case 1:
    //     this.$refs.form1?.validate();
    //     break;
    //   case 2:
    //     this.$refs.form2?.validate();
    //     break;
    //   case 3:
    //     this.$refs.form3?.validate();
    //     break;
    // }
  }

  // handleKeyNavigation(event: KeyboardEvent) {
  //   // arrow left => previous step
  //   if (event.key === 'ArrowLeft' && this.currentStepIndex > 0) {
  //     this.previousStep();
  //   }

  //   // arrow right => next step
  //   if (event.key === 'ArrowRight' && !this.isLastStep && this.isCurrentStepValid) {
  //     this.nextStep();
  //   }
  // }

  async goToStep(index: number) {
    if (index < 1 || index > this.steps.length || index == this.currentStepIndex) return;

    // Optional: Validierung vor dem Sprung zu einem späteren Schritt
    if (index > this.currentStepIndex && this.isCurrentStepValid) {
      this.validateCurrentStep();
    if (!this.isCurrentStepValid) return;

    // Validate previous steps if needed
      for (let i = this.currentStepIndex; i < index; i++) {
        const step = this.steps[i - 1];
        if (!step.isValid) {
          // break, because step from data is not valid
          return;
        }
      }
    }

    this.currentStepIndex = index;
  }

  async previousStep() {
    if (this.currentStepIndex > 1) {
      this.currentStepIndex--;
    }
  }

  async nextStep() {
    this.validateCurrentStep();

    if (!this.isLastStep && this.isCurrentStepValid) {
      this.currentStepIndex++;
    } else if (this.isLastStep && this.isCurrentStepValid) {
      this.onReplaceOldCourse();
    }
  }

  onClose() {
    this.syncedShowDialog = false;
  }
}
